import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DayOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <Path
      d="M9.4 12H7.37a.94.94 0 0 0-.94.94v1.38c0 .52.42.94.94.94H9.4c.52 0 .94-.42.94-.94v-1.38A.94.94 0 0 0 9.4 12Z"
      fill={color}
    />
    <Path
      d="M17.51 6.82c1.04 0 1.89.85 1.89 1.89v8.5c0 1.04-.85 1.89-1.89 1.89H6.49c-1.04 0-1.89-.85-1.89-1.89V8.7c0-1.04.85-1.89 1.89-1.89h11.03m0-1.6H6.49A3.5 3.5 0 0 0 3 8.7v8.5a3.5 3.5 0 0 0 3.49 3.49h11.03a3.5 3.5 0 0 0 3.49-3.49V8.7a3.5 3.5 0 0 0-3.49-3.49Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.22a.8.8 0 0 1 .8.8v1.95a.8.8 0 0 1-1.6 0V4.02a.8.8 0 0 1 .8-.8ZM15.85 3.22a.8.8 0 0 1 .8.8v1.95a.8.8 0 0 1-1.6 0V4.02a.8.8 0 0 1 .8-.8ZM20 10.8H4.14V9.2H20v1.6Z"
      fill={color}
    />
  </Svg>
)

export default DayOutlined
